<template>
  <MobileServiceOverview
    class="industry-view"
    v-bind="industryOverview"
    :hero-image="industryHeroImage"
  />
</template>

<script>
import MobileServiceOverview from '@/components/content/MobileServiceOverview.vue'
import industryHeroImage from '@/assets/shared/images/service-overview-mobile-hero.webp'

export default {
  name: 'IndustryView',
  components: {
    MobileServiceOverview
  },
  data() {
    return {
      industryHeroImage,
      industryOverview: {
        eyebrow: '智谷工业',
        title: '管道安全数智化解决方案',
        summary: '围绕无损检测平台、智能检测算法与智能检测硬件，推动关键技术国产化，并以真实工业场景持续验证成果。',
        metrics: [
          { value: '15年', label: '管道领域研究经验' },
          { value: '102项', label: '申报发明专利' },
          { value: '61项', label: '已授权专利' },
          { value: '2000万+', label: '落地案例合同额' }
        ],
        highlights: [
          {
            kicker: '核心方向',
            title: '安全检测国产化',
            description: '聚焦无损检测平台、智能检测算法与智能检测硬件，实现管道安全关键技术自主突破。'
          },
          {
            kicker: '科技创新',
            title: '科研与成果转化',
            description: '科研项目合同额5000万元、科研成果转化额1060万元，持续推动技术从实验室走向应用。'
          },
          {
            kicker: '产品矩阵',
            title: '覆盖管道业务全流程',
            description: '覆盖检测管理、质量评价、泄漏检测、GIS展示、模型训练与检测数据智能分析等场景。'
          }
        ]
      }
    }
  }
}
</script>
